import React, { useState } from 'react';
import { getApiEndpoint } from '../../../config/api';
import './StaffDashboard.css';

export default function ReportIssue() {
  const [form, setForm] = useState({ title: '', description: '', property: '', property_id: '' });
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleChange = e => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const token = localStorage.getItem('token');
      const res = await fetch(getApiEndpoint('/api/staff/report-issue'), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({
          title: form.title,
          description: form.description,
          property_name: form.property || null,
          property_id: form.property_id ? parseInt(form.property_id, 10) : null
        })
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(data.message || 'Failed to report issue');
      setSubmitted(true);
    } catch (err) {
      setError(err.message || 'Failed to submit. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  if (submitted) {
    return <div className="overview-card">Thank you! Your issue has been reported.</div>;
  }

  return (
    <form className="overview-card" onSubmit={handleSubmit} style={{ maxWidth: 500 }}>
      <h3>Report an Issue</h3>
      {error && <div style={{ color: '#c0392b', marginBottom: '0.75rem' }}>{error}</div>}
      <div className="input-group">
        <label>Title</label>
        <input name="title" value={form.title} onChange={handleChange} required />
      </div>
      <div className="input-group">
        <label>Description</label>
        <textarea name="description" value={form.description} onChange={handleChange} required />
      </div>
      <div className="input-group">
        <label>Property (name or leave blank)</label>
        <input name="property" value={form.property} onChange={handleChange} placeholder="e.g. Main Building" />
      </div>
      <div className="input-group">
        <label>Property ID (optional)</label>
        <input name="property_id" type="number" value={form.property_id} onChange={handleChange} placeholder="If you know the property ID" />
      </div>
      <button className="btn-primary" type="submit" disabled={loading}>{loading ? 'Submitting…' : 'Submit'}</button>
    </form>
  );
} 